import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=c4f7a2ea&scoped=true&"
import script from "./Manage.vue?vue&type=script&lang=ts&"
export * from "./Manage.vue?vue&type=script&lang=ts&"
import style0 from "./Manage.vue?vue&type=style&index=0&id=c4f7a2ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f7a2ea",
  null
  
)

export default component.exports